export const resolveApiBaseList = () => {
  const baseList = [];
  const seen = new Set();

  const pushBase = (value) => {
    if (!value) return;
    const normalized = value.replace(/\/$/, '');
    if (!seen.has(normalized)) {
      seen.add(normalized);
      baseList.push(normalized);
    }
  };

  const pushWithApi = (value, { includeRaw = false } = {}) => {
    if (!value) return;
    const normalized = value.replace(/\/$/, '');
    if (includeRaw) pushBase(normalized);
    pushBase(`${normalized}/api`);
    pushBase(`${normalized}/backend`);
  };

  const envBase = process.env.REACT_APP_API_BASE?.trim();
  if (envBase) pushWithApi(envBase, { includeRaw: true });

  if (typeof window !== 'undefined') {
    const { origin, hostname } = window.location;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      pushWithApi('http://localhost:3001', { includeRaw: true });
      pushWithApi('http://127.0.0.1:3001', { includeRaw: true });
    }

    pushWithApi(origin);
    pushWithApi('https://institutosilvianocarrillo.com');
    pushWithApi('https://www.institutosilvianocarrillo.com');
  }

  pushBase('/api');
  pushBase('/backend');

  return baseList;
};
